module.exports = __webpack_public_path__ + "media/images/sale_crm/dep_cal-571d530e8f562a201ece1801870304eb.svg";